import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import moment from "moment";
const SubjectEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [isFinancialYear, setFinancialYear] = useState(props ? props.isFinancialYearRec : {});
 
  const checkRequiredFields = () => {
    if (
      isFinancialYear.name &&
      isFinancialYear.name.trim() !== "" &&
      isFinancialYear.startdate &&
      isFinancialYear.startdate.trim() !== "" &&
      isFinancialYear.enddate &&
      isFinancialYear.enddate.trim() !== ""
    ) {
     
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    let result2 = {};

    if (isFinancialYear.id) {
      result2 = await trasportApi.saveFinancialYear(isFinancialYear);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      result2 = await trasportApi.createFinancialYear(isFinancialYear);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handleFinancial  = async (e) => {
    setFinancialYear({ ...isFinancialYear, [e.target.name]: e.target.value });
  };

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        Financial Year
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                         Year
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        placeholder="Enter Year Name"
                        value={isFinancialYear.name}
                        onChange={handleFinancial }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Start Date
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="startdate"
                        placeholder="Enter Start Date"
                        value={isFinancialYear ? moment(isFinancialYear.startdate).format("YYYY-MM-DD") : ''}
                        onChange={handleFinancial }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        End Date
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="enddate"
                        placeholder="Enter End date"
                        value={isFinancialYear ? moment(isFinancialYear.enddate).format("YYYY-MM-DD") : ''}
                        onChange={handleFinancial}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Is Active
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                    checked={isFinancialYear.isactive ? true:false}
                     value={isFinancialYear.isactive}
                      onClick={(e) =>{setFinancialYear({ ...isFinancialYear, [e.target.name]: e.target.checked});}}
                      name="isactive"
                    />
                    </Form.Group>
                    </Col>   
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;
